import React from 'react'
import ReconciliacaoPixAutomaticoListPageContainer from './ReconciliacaoPixAutomaticoListPageContainer'

export class ReconciliacaoPixAutomaticoListPage extends React.Component {
  render() {
    return <ReconciliacaoPixAutomaticoListPageContainer {...this.props} />
  }
}
